import styles from "./UserPoints.module.css";

const userPointsStyles = {
    outerContainer: `flex items-center justify-center gap-[40px] bg-themeShadowColor border border-liveGamePrimaryColor py-[15px] px-[20px] rounded-[10px] w-full ${styles.outerContainer}`,
    pointsContainer: `flex flex-col gap-3 items-center font-Suisse font-[700] ${styles.pointsContainer}`,
    divider: `min-w-[1px] w-[1px] h-[45px] bg-liveGamePrimaryColor ${styles.divider}`,
    pointsText: `text-[28px] font-[600] text-white text-stroke leading-[30px] ${styles.pointsText}`,
    pointsHeading: `text-[15px] leading-[18px] uppercase text-center ${styles.pointsHeading}`,
}

export { userPointsStyles }